<template>
  <v-dialog v-model="dialog" width="600px">
    <v-card>
      <v-card-title class="white--text primary"
        >NHẬN XÉT LỚP HỌC
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-divider></v-divider>
      <v-form ref="form" class="pa-6">
        <v-text-field
          label="Điểm lớp học"
          v-model="classMarkInput"
          dense
          outlined
          class="required"
          type="number"
          :rules="[$rules.required, $rules.min(0), $rules.max(10)]"
        ></v-text-field>
        <v-textarea
          v-model="classCommentInput"
          class="required"
          :rules="[$rules.required]"
          label="Nhận xét của Giáo viên"
          outlined
        ></v-textarea>
      </v-form>

      <v-divider></v-divider>
      <v-row class="px-6 pb-6 mt-6" no-gutters>
        <v-btn class="px-6" outlined light depressed @click="cancel">Hủy</v-btn>
        <v-spacer></v-spacer>
        <v-btn class="px-6" depressed color="primary" @click="save">Lưu</v-btn>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { get } from 'lodash'

export default {
  components: {},
  props: {
    state: Boolean,
    classComment: String,
    classMark: Number
  },
  data() {
    return {
      dialog: false,
      loading: false,
      classCommentInput: get(this.slot, 'classNote.data.classComment', ''),
      classMarkInput: get(this.slot, 'classNote.data.classMark', '')
    }
  },
  computed: {
    ...mapState('ClassNoteDetail', ['slot']),
    ...mapGetters('ClassNoteDetail', ['classNoteDetailData'])
  },

  methods: {
    ...mapActions('ClassNoteDetail', ['updateClassComment']),
    async save() {
      if (!this.$refs.form.validate()) return

      this.$loading.active = true
      try {
        await this.updateClassComment({
          ...this.classNoteDetailData,
          data: {
            classComment: this.classCommentInput,
            classMark: +this.classMarkInput
          }
        })

        this.$alert.updateSuccess()
        this.dialog = false
      } catch (error) {
        this.$alert.updateError(error)
      } finally {
        this.$loading.active = false
      }
    },
    cancel() {
      this.dialog = false
    }
  },
  watch: {
    state(state) {
      this.dialog = true
    },
    classComment: {
      handler(val) {
        this.classCommentInput = val
      },
      immediate: true
    },
    classMark: {
      handler(val) {
        this.classMarkInput = val
      },
      immediate: true
    }
  }
}
</script>
